// ✅ Selectors
export const selectAssessmentResultsList = (state) => state?.assessmentResults?.getAssessmentResults?.data || [];
export const selectAssessmentResultsLoading = (state) => state?.assessmentResults?.getAssessmentResults?.loading;
export const selectAssessmentResultsError = (state) => state?.assessmentResults?.getAssessmentResults?.error;
export const selectAssessmentResultsTotal = (state) => state?.assessmentResults?.getAssessmentResults?.total || 0;

export const selectAssessmentResultsState = (state) => state?.assessmentResults;
